import type { TabsProps } from 'antd';
import { Button, Empty, Input, Tabs } from 'antd';
import { useContext, useState } from 'react';
import { ItemButton, MemberTree, RoleTree } from './components/index';
import type { SelectMember, SelectRole } from '../types';

import { RoleType } from './constant';

import styles from './SelectRoleOrPerson.less';
import cx from 'classnames';
import { PeopleRoleSelectContext } from '@/components/PeopleRoleSelect/context';

interface SelectRoleOrPersonProps {
  groupNodes: SelectRole[];
  setGroupNodes: (groupNodes: SelectRole[]) => void;
  memberNodes: SelectMember[];
  setMemberNodes: (memberNodes: SelectMember[]) => void;
  value: string;
  onChange: (value: string) => void;
  searchValue: string;
  onChangeSearchValue: (value: string) => void;
  needCustom: boolean;
  haveRightSide?: boolean;
}

export const SelectRoleOrPerson = ({
  groupNodes,
  setGroupNodes,
  memberNodes,
  setMemberNodes,
  value,
  onChange,
  searchValue,
  onChangeSearchValue,
  needCustom,
  haveRightSide = true,
}: SelectRoleOrPersonProps) => {
  const PeopleRoleSelectContextProps = useContext(PeopleRoleSelectContext);
  const { mode, selectHeight } = PeopleRoleSelectContextProps;
  const [activeKey, setActiveKey] = useState(RoleType.Role);

  const onDelete = (id: string) => {
    setGroupNodes(groupNodes.filter((node) => String(node.id) !== String(id)));
    setMemberNodes(memberNodes.filter((node) => String(node.id) !== String(id)));
  };

  const items: TabsProps['items'] = [
    {
      key: RoleType.Role,
      label: '按角色',
      children: (
        <div
          className={styles.content}
          style={{ height: mode === 'select' ? selectHeight : 'auto' }}
        >
          <RoleTree
            groupNodes={groupNodes}
            setGroupNodes={setGroupNodes}
            searchValue={searchValue}
            needCustom={needCustom}
          />
        </div>
      ),
    },
    {
      key: RoleType.Person,
      label: '按人员',
      children: (
        <div
          className={styles.content}
          style={{ height: mode === 'select' ? selectHeight : 'auto' }}
        >
          <MemberTree
            memberNodes={memberNodes}
            setMemberNodes={setMemberNodes}
            searchValue={searchValue}
          />
        </div>
      ),
    },
  ];

  return (
    <div className={cx(styles.frame, haveRightSide && styles.in_modal)}>
      <div className={styles.tree}>
        <Tabs
          activeKey={activeKey}
          items={items}
          tabBarExtraContent={
            <Input.Search
              placeholder="搜索人员或角色"
              style={{ width: 196 }}
              value={value}
              onSearch={(tempValue) => {
                onChangeSearchValue(tempValue);
              }}
              onChange={(e) => onChange(e.target.value)}
            />
          }
          onChange={(key: string) => setActiveKey(key as RoleType)}
        />
      </div>
      {haveRightSide && (
        <div className={styles.selected}>
          <div className={styles.title}>
            已选 {groupNodes.length + memberNodes.length} 项
            <Button
              type="link"
              onClick={() => {
                setGroupNodes([]);
                setMemberNodes([]);
              }}
            >
              清空
            </Button>
          </div>
          {haveRightSide && (
            <div className={styles.content}>
              {groupNodes.length + memberNodes.length > 0 ? (
                <>
                  {groupNodes.length > 0 && (
                    <>
                      <div>角色</div>
                      {groupNodes.map((item) => (
                        <ItemButton
                          key={item.id}
                          name={item.completeName}
                          id={item.id}
                          onDelete={onDelete}
                        />
                      ))}
                    </>
                  )}
                  {memberNodes.length > 0 && (
                    <>
                      <div style={{ marginTop: 16 }}>人员</div>{' '}
                      {memberNodes.map((item) => (
                        <ItemButton
                          key={item.id}
                          name={item.completeName}
                          id={item.id}
                          onDelete={onDelete}
                        />
                      ))}
                    </>
                  )}
                </>
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="请在左侧选择人员或角色"
                  style={{ marginTop: 80 }}
                />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
